import * as React from 'react';

// HOC
import { withUserWebView } from '@shopee-user/with-web-view';

// Hook
import { useTranslation } from '@shopee-user/platform';

// Components
import { IconNotification20 } from '@nebula/icon';
import { Tip } from '@shopee-user/shared-customization-ui';

// Constants
import { config } from '@shopee-user/platform';
import { Locale } from '@shopee-user/global';

// Types
import { WithUserWebViewProps } from '@shopee-user/with-web-view';
import { SupportedLocale } from '@shopee-user/spx-customization-logic';

import styles from './style.scss';

const interestFormUrl =
  config.ENV === 'live'
    ? 'https://spx.sg/interest-form'
    : `https://${config.ENV}.spx.sg/interest-form`;

function LoginByPasswordTip({ webViewNavigateToUrl }: WithUserWebViewProps) {
  const I18n = useTranslation();

  switch (config.LOCALE as SupportedLocale) {
    // TODO: check with PM if tip is needed for ID. long term SPX migrate out one credential
    case Locale.ID:
      return (
        <Tip
          icon={<IconNotification20 color="#f69113" />}
          className={styles.tipContainer}
          type="caution"
        >
          {I18n.t('label_auth_please_use_your_linked_shopee_account_to_login')}
        </Tip>
      );
    case Locale.SG:
      return (
        <Tip
          icon={<IconNotification20 color="#f69113" />}
          title={I18n.t('label_auth_are_you_an_enterprise_account')}
          type="caution"
          className={styles.tipContainer}
        >
          <div className={styles.tipDescription}>
            {I18n.tNode('label_auth_interest_new_enterprise_account', {
              label_now: (
                <a
                  className={styles.link}
                  onClick={ev => {
                    ev.preventDefault();
                    webViewNavigateToUrl(interestFormUrl);
                  }}
                >
                  {I18n.t('label_auth_now')}
                </a>
              ),
            })}
          </div>
        </Tip>
      );
    default:
      return null;
  }
}
export default withUserWebView({})(LoginByPasswordTip);
